import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Loadable from '@loadable/component';
import { Col, Container, Row } from 'react-bootstrap';

import './banner.styles.scss';

const Fade = Loadable(() => import('react-reveal/Fade'));
const Pulse = Loadable(() => import('react-reveal/Pulse'));

const Banner: React.FC = () => {
  return (
    <div className="banner">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12}>
            <div className="banner-content">
              <Fade right>
                <h1>Moving People</h1>
              </Fade>
              <Pulse>
                <p>
                  Hop In provides a logistics software service that offers a
                  customized shuttle solution for the daily commute. Our shuttle
                  solutions help companies improve access to the workplace by
                  extending the reach of transit.
                </p>
              </Pulse>
              <Pulse>
                <div className="btn-box">
                  <AniLink
                    paintDrip
                    hex="#ff5d22"
                    to="/contact"
                    className="default-btn"
                  >
                    Get Started <i className="flaticon-right"></i> <span></span>
                  </AniLink>
                </div>
              </Pulse>
            </div>
          </Col>

          <Col lg={6} md={12}>
            <Fade left>
              <div className="banner-wrapper-image">
                <img
                  src={require('../../assets/photos/banner/hopin-custom-banner.png')}
                  alt="hopin bus"
                />
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
